module.exports = "<mat-card fxLayout=\"column\" layout-padding>\r\n\r\n    <h2>{{entityNames}}</h2>\r\n\r\n    <div fxLayout=\"row\">\r\n        <span fxFlex></span>\r\n\r\n        <a *ngIf=\"isPermissionWriteOrAdmin\" mat-button class=\"lower-case\" uiSref=\"{{newEntityState}}\">\r\n            <mat-icon class=\"material-icons\">add</mat-icon>\r\n            <span class=\"image-button-label\">New {{entityName}}</span>\r\n        </a>\r\n    </div>\r\n\r\n    <crew-list [items]=\"entities\"\r\n               [detailsState]=\"editEntityState\">\r\n    </crew-list>\r\n</mat-card>"


//////////////////
// WEBPACK FOOTER
// ./client/app/settings/shared/list-view.html
// module id = 79
// module chunks = 1